import script from "./ConfirmSwapModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmSwapModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmSwapModal.vue?vue&type=style&index=0&id=2d5e649c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d5e649c"]])

export default __exports__